import { memo } from 'react'

import { useIdentify } from '@repo/common/queries/auth'

export const UserIdentify = memo(function UserIdentify() {
  useIdentify()

  return null
})
